import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";
import { Container, GoldRule } from "@/components/shared";
import AdSlot from "@/components/AdSlot";

const days = [
  {
    shore: "Lincolnshire",
    accent: "#003366",
    label: "Days one & two — the mother town",
    items: [
      { d: "Day 1", t: "Arrive & the Stump", b: "Settle in, then walk to St Botolph's. Climb the tower if you can, and take your bearings the way the sailors did." },
      { d: "Day 1", t: "Market Place & Guildhall", b: "Browse the market, then visit the Guildhall to hear how emigrants were once held here before the crossing." },
      { d: "Day 2", t: "The Haven", b: "Follow the river to the working Haven. Watch the boats, and understand why a Fenland town looks always to the water." },
      { d: "Day 2", t: "Makers & departure", b: "Call on a maker or two — a smokehouse, a bookshop — before you turn west for the daughter city." },
    ],
  },
  {
    shore: "The crossing",
    accent: "#CDA434",
    label: "The voyage — an ocean between",
    items: [
      { d: "In between", t: "The Atlantic", b: "The settlers took weeks; you will take hours. However you cross, it is worth marking the distance the name once travelled." },
    ],
  },
  {
    shore: "Massachusetts",
    accent: "#1E1E2F",
    label: "Days three & four — the daughter city",
    items: [
      { d: "Day 3", t: "Harbour & waterfront", b: "Begin at the water, as the city did. Walk the wharves and feel the scale of the harbour that kept the name." },
      { d: "Day 3", t: "Boston Common", b: "Cross the Common, the country's oldest public park, and read the growth of the settlement in its ground." },
      { d: "Day 4", t: "The North End", b: "Spend the morning among the makers — copper, clay, small kitchens — in the old streets near the water." },
      { d: "Day 4", t: "A last look", b: "End where the two Bostons meet in your mind: same name, two harbours, one crossing kept open." },
    ],
  },
];

export default function StumpToCommon() {
  const [adSlot, setAdSlot] = useState(null);
  useEffect(() => {
    api.get("/adslots", { params: { page: "visit" } }).then((r) => setAdSlot(r.data[0] || null));
  }, []);

  return (
    <div>
      <PageHero
        kicker="Itinerary · The signature crossing"
        title="Stump to Common"
        intro="A four-day route across both shores — two days in Lincolnshire, an ocean, and two days in Massachusetts. A sketch, not a timetable; adjust it to your own tides."
        dark
      />

      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-3xl mx-auto space-y-16">
            {days.map((day, di) => (
              <div key={di}>
                <div className="flex items-center gap-3 mb-8">
                  <span className="w-3 h-3 rounded-full" style={{ background: day.accent }} />
                  <span className="font-sans text-xs uppercase tracking-[0.2em] text-[#505A68]">{day.label}</span>
                  <div className="flex-1 h-px bg-[#D6D3CB]" />
                </div>
                <div className="space-y-6">
                  {day.items.map((it, i) => (
                    <div key={i} className="flex gap-5">
                      <span className="font-playfair italic text-sm text-[#CDA434] w-20 shrink-0 pt-1">{it.d}</span>
                      <div className="flex-1 pb-6 border-b border-[#D6D3CB]/70">
                        <h3 className="font-serif text-lg text-[#1E1E2F] mb-1.5">{it.t}</h3>
                        <p className="font-sans text-sm text-[#1B2430] leading-relaxed">{it.b}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Ad strip at the foot of the itinerary */}
      {adSlot && (
        <Container className="pb-20">
          <div className="max-w-3xl mx-auto">
            <AdSlot slot={adSlot} variant="strip" />
          </div>
        </Container>
      )}
    </div>
  );
}
